import { createStyles, makeStyles, Theme } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import Close from "@material-ui/icons/Close";
import { TagCloud } from "react-tagcloud";
import { FONTS, SECONDARY_COLOR } from "../../constants";
import { formatNumber } from "../../helpers/FormatNumber";
import { stateType, stateTypeF } from "../../state";
import { cloudDataType } from "../NLP/textProcessor";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      margin: "3px",
      padding: "3px",
      display: "inline-block",
      border: "solid",
      borderColor: "rgba(0,0,0,0)",

      fontFamily: FONTS,
      cursor: "pointer",
      transition: "0.4s",
      "&:hover": { border: "solid" },
    },
    popupText: {
      fontFamily: FONTS,
      marginLeft: "20px",
      marginBottom: "10px",
      fontSize: "15px",
    },
    arrowLeft: {
      "&:hover": { transform: "scale(1.2)" },
      transition: "0.2s",
      width: "17px",
      cursor: "pointer",
    },
    arrowRight: {
      "&:hover": { transform: "scale(1.2) rotate(180deg)" },
      transform: "rotate(180deg)",
      width: "17px",
      marginRight: "8px",
      transition: "0.2s",
      cursor: "pointer",
    },
    close: {
      "&:hover": { transform: "scale(1.1)" },
      transition: "0.2s",
      width: "22px",
      cursor: "pointer",
    },
  })
);

type cloudChartType = {
  state: stateTypeF;
  data: cloudDataType[];
  title: string;
};

const customRenderer = (tag, size, color, classes) => {
  return (
    <span
      key={tag.value}
      className={classes.text}
      style={{
        color: color,
        fontSize: `${size / 1.2}px`,
      }}
    >
      {tag.value}
    </span>
  );
};

export function CloudChart({ state, data, title }: cloudChartType) {
  const ndx = state.saveState.topicModeling.varSelected;
  const cloudData =
    state.saveState.dataset.visualizationData[ndx].topicCloudData;

  const classes = useStyles();
  if (data === undefined) {
    return <div></div>;
  }
  const options = {
    luminosity: "medium",
    hue: SECONDARY_COLOR,
  };

  function handleClick(tag, size, color) {
    state.setTagClicked(tag.value);
    state.setIsCloudPopupOpen(true);
  }

  return (
    <div
      style={{
        textAlign: "center",
        justifyContent: "center",
        textOverflow: "clip",
        width: "100%",
        whiteSpace: "normal",
        marginRight: "0px",
      }}
    >
      <div
        style={{
          fontFamily: FONTS,
          marginBottom: "20px",
          fontSize: "25px",
          fontWeight: "bold",
          marginTop: "-42px",
          marginLeft: "50px",
          marginRight: "50px",
        }}
      ></div>

      <TagCloud
        minSize={15}
        maxSize={75}
        shuffle={true}
        colorOptions={options}
        renderer={(tag, size, color) =>
          customRenderer(tag, size, color, classes)
        }
        randomSeed={1988}
        tags={data}
        onClick={(tag, size, color) => handleClick(tag, size, color)}
      />
      <CloudPopUp state={state}></CloudPopUp>
    </div>
  );
}

type cloudPopupType = {
  state: stateTypeF;
  term: string;
  sentScore: string;
  freq: string;
};
function CloudPopUp({ state }: stateType) {
  const classes = useStyles();
  const ndx = state.saveState.topicModeling.varSelected;
  const cloudData =
    state.saveState.dataset.visualizationData[ndx].topicCloudData;
  let docs = cloudData.topicDocs[state.tagClicked] as string[];
  const appearsIn = cloudData.topicDocsCounts[state.tagClicked];
  let pageSelected = state.cloudPopupPageSelected;

  if (docs === undefined) {
    return <div></div>;
  }

  let doc = "";
  if (pageSelected >= docs.length) {
    pageSelected = docs.length - 1;
    state.setCloudPopupPageSelected(pageSelected);
  } else if (pageSelected < 0) {
    pageSelected = 0;
    state.setCloudPopupPageSelected(pageSelected);
  }
  doc = docs[pageSelected];

  function handleArrowClick(increment: number) {
    let newPage = state.cloudPopupPageSelected + increment;
    let nDocs = docs.length;
    newPage = Math.max(Math.min(newPage, nDocs - 1), 0);
    state.setCloudPopupPageSelected(newPage);
  }

  return (
    <Dialog
      open={state.isCloudPopupOpen}
      maxWidth="sm"
      onClose={() => state.setIsCloudPopupOpen(false)}
      PaperProps={{
        style: {
          // backgroundColor: "white",
          // borderRadius: "20px",
          backgroundImage:
            "linear-gradient(to right top, #ffffff, #fdfdfd, #fbfbfb, #f9f9f9, #f7f7f7, #f7f7f7, #f7f7f7, #f7f7f7, #f9f9f9, #fbfbfb, #fdfdfd, #ffffff)",
        },
      }}
    >
      <DialogContent
        style={{
          display: "flex",
          flexDirection: "row",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "400px",
            marginTop: "-30px",
            marginLeft: "-30px",
            marginRight: "-30px",
            color: "rgba(0,0,0,0.7)",
          }}
        >
          {/* <BoxHeader
            title={`Topic Summary for: '${state.tagClicked}'`}
            toolTip={""}
            color={PRIMARY_COLOR}
            showTip={false}
            line={true}
          ></BoxHeader> */}
          <div
            style={{
              fontFamily: FONTS,
              marginTop: "20px",
              fontSize: "25px",
              marginLeft: "20px",
              marginBottom: "30px",
              fontWeight: "bold",
              color: "black",
              display: "flex",
            }}
          >
            <div
              style={{
                width: "300px",
                // backgroundColor: "red",
              }}
            >
              Topic:{" "}
              <span style={{ color: SECONDARY_COLOR }}>
                {" "}
                '{state.tagClicked}'
              </span>
            </div>
            <Close
              style={{
                marginRight: "20px",
                marginLeft: "auto",
                marginTop: "-3px",
                color: "rgba(0,0,0,0.5)",
              }}
              className={classes.close}
              onClick={() => {
                state.setIsCloudPopupOpen(false);
                state.setCloudPopupPageSelected(0);
              }}
            ></Close>
          </div>
          <div className={classes.popupText} style={{ marginTop: "-20px" }}>
            <span>Appears in:</span> {`${formatNumber(appearsIn)} documents`}
          </div>
          {
            //<div className={classes.popupText}>
            //	<span>Sentiment:</span> {Math.round(sentiment)} ({label}
            //	)
            //</div>
          }

          <div
            style={{
              fontFamily: FONTS,
              marginLeft: "23px",
              fontSize: "20px",
              marginTop: "50px",
              fontWeight: "bold",
              display: "flex",
              color: "black",
              justifyContent: "space-between",
            }}
          >
            <div>Example Documents</div>
            <div style={{ marginRight: "20px", display: "flex" }}>
              <div
                style={{
                  fontSize: "15px",
                  lineHeight: "25px",
                  marginRight: "5px",
                }}
              >
                {`${formatNumber(
                  state.cloudPopupPageSelected + 1
                )} of ${formatNumber(docs.length)}`}
              </div>
              <ArrowForwardIosIcon
                className={classes.arrowRight}
                onClick={() => handleArrowClick(-1)}
              ></ArrowForwardIosIcon>
              <ArrowForwardIosIcon
                className={classes.arrowLeft}
                onClick={() => handleArrowClick(1)}
              ></ArrowForwardIosIcon>
            </div>
          </div>

          <div
            style={{
              marginTop: "5px",
              marginLeft: "20px",
              marginBottom: "10px",
              marginRight: "20px",
              overflowY: "scroll",
              height: "170px",
              // backgroundColor: "rgba(0,0,0,0.05)",
              border: "solid",
              borderRadius: "5px",
            }}
          >
            <div
              style={{
                margin: "10px",
                marginTop: "5px",
                fontFamily: FONTS,
                lineHeight: "23px",
                // color: "black",
                fontWeight: 200,
                color: "rgba(0,0,0,0.8)",

                height: "160px",
              }}
            >
              {doc}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
